/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDRadiusUpRightIcon64Regular = forwardRef('ArrowDRadiusUpRightIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M40.553 7.932a1.5 1.5 0 1 0-2.106 2.136L53.361 24.77c.368.363.648.782.838 1.23H32.5C18.417 26 7 37.417 7 51.5v2a1.5 1.5 0 0 0 3 0v-2C10 39.074 20.074 29 32.5 29h21.699c-.19.448-.47.867-.838 1.23L38.447 44.932a1.5 1.5 0 1 0 2.106 2.136l14.914-14.702a6.833 6.833 0 0 0 0-9.732L40.553 7.932Z" })));
});
